/** 用户的 VIP 信息 */

/** 会员过期状态 */
export var ExpiredStatus = /*#__PURE__*/function (ExpiredStatus) {
  ExpiredStatus[ExpiredStatus["Unexpired"] = 0] = "Unexpired";
  ExpiredStatus[ExpiredStatus["Expired"] = 1] = "Expired";
  return ExpiredStatus;
}({});

/** 会员等级. */
export var VipLevel = /*#__PURE__*/function (VipLevel) {
  VipLevel[VipLevel["None"] = 1] = "None";
  VipLevel[VipLevel["Normal"] = 2] = "Normal";
  VipLevel[VipLevel["Super"] = 3] = "Super";
  return VipLevel;
}({});

/** 续费状态. */
export var RenewalStatus = /*#__PURE__*/function (RenewalStatus) {
  RenewalStatus[RenewalStatus["None"] = 0] = "None";
  RenewalStatus[RenewalStatus["Open"] = 1] = "Open";
  RenewalStatus[RenewalStatus["Closed"] = 2] = "Closed";
  return RenewalStatus;
}({});
//# sourceMappingURL=vip.js.map